import { CustomCalenderOptions } from '../../calendar-wrapper/models';

export enum ComponentMode {
	CREATE = 'CREATE',
	EDIT = 'EDIT',
	READ = 'READ',
}

export interface VisitScheduleOptions extends CustomCalenderOptions {
	mode?: ComponentMode;
	listener?:string;
	resource?: {
		key?:string;
		query?:string
	};
}
